<template>
  <div ref="headerScrollRef" />
</template>

<script setup lang="ts">
const headerScrollRef = useTemplateRef('headerScrollRef')
const headerScrollBottomPos = useHeaderScrollBottomPosState()

onMounted(() => {
  let disposed = false

  const updateHeaderScrollBottomPos = useThrottleFn(() => {
    if (!disposed && headerScrollRef.value) {
      headerScrollBottomPos.value = headerScrollRef.value.getBoundingClientRect().top + document.documentElement.scrollTop
    }
  })

  useEventListener(window, ['scroll', 'resize'], updateHeaderScrollBottomPos, { passive: true })

  tryOnScopeDispose(() => {
    disposed = true
    headerScrollBottomPos.value = 0
  })

  updateHeaderScrollBottomPos()
})
</script>
